// Auth0 configuration from build-time env. When domain/clientId are absent,
// auth is DISABLED and the app talks to an unprotected (local-dev) API.

export const authConfig = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN ?? '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? '',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? '',
};

export const authEnabled = Boolean(authConfig.domain && authConfig.clientId);
